import { render } from "./humVideoPlayer.vue?vue&type=template&id=2855f352&scoped=true"
import script from "./humVideoPlayer.vue?vue&type=script&lang=js"
export * from "./humVideoPlayer.vue?vue&type=script&lang=js"

import "./humVideoPlayer.vue?vue&type=style&index=0&id=2855f352&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2855f352"]])

export default __exports__